import { makeStyles } from "@material-ui/core/styles"

const drawerListStyles = makeStyles((theme) => ({
  newrequestButton: {
    marginTop: "10px",
    color: theme.palette.secondary.main,
  },
}))

export default drawerListStyles
